import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';

function hideUploadsForOthers(component, vnode) {
  const post = component.attrs.post;
  const actor = app.session.user;

  // 投稿情報がなければ何もしない
  if (!post) return;

  const owner = post.user();
  const isOwner = !!actor && !!owner && actor.id() === owner.id();
  const isAdmin = !!actor && actor.attribute && actor.attribute('isAdmin');

  // 投稿者 or 管理者はそのまま表示
  if (isOwner || isAdmin) {
    console.log('User is owner or admin; showing uploads');
    return;
  }

  console.log('Hiding uploads for non-owners');

  // ▼ ここがポイント：DOM の取得方法
  // Flarum Component は this.element にルートDOMが入る
  const dom = component.element || (vnode && vnode.dom);
  if (!dom) {
    console.log('No DOM element found on component');
    return;
  }

  console.log('DOM is available for manipulation', dom);

  // 投稿本文の中だけを見る方が安全
  const body = dom.querySelector('.Post-body') || dom;

  // fof/upload が吐く画像のセレクタ（ここは実際のDOMに合わせて）
  const uploadNodes = body.querySelectorAll(
    'img.FoFUpload--Upl-Image-Preview'
  );

  console.log(`Found ${uploadNodes.length} upload nodes to hide`);

  uploadNodes.forEach((node) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'UploadHiddenMessage';
    wrapper.textContent = app.translator.trans(
      'butterflycode-upload-visibility.forum.cannot_view_image'
    );

    node.replaceWith(wrapper);
  });
}

app.initializers.add('butterflycode-upload-visibility', () => {
  // Post 初回描画時
  extend(CommentPost.prototype, 'oncreate', function (vnode) {
    console.log('oncreate hook triggered');
    hideUploadsForOthers(this, vnode);
  });

  // Post 更新時（スクロールで後からロードされたときなど）
  extend(CommentPost.prototype, 'onupdate', function (vnode) {
    console.log('onupdate hook triggered');
    hideUploadsForOthers(this, vnode);
  });
});
